import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { HashRouter } from 'react-router-dom';
import "@amzn/meridian-tokens/base/font/amazon-ember.css";
import {IntlProvider, addLocaleData} from "react-intl";
import {getDirection, getLocale, getMessages} from "./handler/LocaleHandler";
import App from "./components/app";
import ErrorBoundary from "./components/ErrorBoundary";
import en from 'react-intl/locale-data/en'
import ja from 'react-intl/locale-data/ja'
import it from 'react-intl/locale-data/it'
import fr from 'react-intl/locale-data/fr'
import es from 'react-intl/locale-data/es'
import de from 'react-intl/locale-data/de'
import ar from 'react-intl/locale-data/ar'
import tr from 'react-intl/locale-data/tr'
import pt from 'react-intl/locale-data/pt'
import FeatureContextProvider from "./commons/context/FeatureConfigContext";
import {DeviceLayoutProvider} from "./commons/context/DeviceLayoutContext";

addLocaleData(en)
addLocaleData(ja)
addLocaleData(it)
addLocaleData(de)
addLocaleData(fr)
addLocaleData(es)
addLocaleData(ar)
addLocaleData(tr)
addLocaleData(pt)

getLocale().then(locale => {
    document.getElementsByTagName(`html`)[0].setAttribute("dir", getDirection(locale));
    ReactDOM.render((
        <IntlProvider locale={locale} messages={getMessages(locale)}>
            <DeviceLayoutProvider>
                <HashRouter>
                    <ErrorBoundary>
                        <FeatureContextProvider>
                            <App/>
                        </FeatureContextProvider>
                    </ErrorBoundary>
                </HashRouter>
            </DeviceLayoutProvider>
        </IntlProvider>
    ), document.getElementById('root'));
})




// WEBPACK FOOTER //
// ./src/index.js